<script setup lang="ts">
import { useHead } from '#app';
import { ref } from 'vue';
import { BASE_TITLE } from '~/utilities/constants';

useHead({
  title: `Top Collections ${BASE_TITLE}`,
  meta: [{ property: 'og:title', content: `Top Collections ${BASE_TITLE}` }],
});

const route = useRoute();
const router = useRouter();

const intervalInDays = ref(route.query.interval ? route.query.interval : '30');
watch(intervalInDays, (intervalInDays) => {
  router.replace({
    path: route.path,
    query: { interval: intervalInDays },
  });
});
</script>

<template>
  <div>
    <div>
      <Container>
        <div class="py-8 sm:py-16">
          <div class="text-center">
            <p
              class="text-4xl font-extrabold text-neutral-900 dark:text-neutral-50 sm:text-5xl sm:tracking-tight lg:text-5xl"
            >
              {{ $t('collections.topCollections') }}
            </p>
          </div>
        </div>
        <div class="w-full">
          <div class="mb-4 flex justify-center">
            <span class="relative z-0 inline-flex rounded-md shadow-sm">
              <button
                type="button"
                :class="[
                  intervalInDays === '7' ? 'z-10 border-emerald-500 outline-none ring-1 ring-emerald-500' : '',
                  'relative inline-flex items-center rounded-l-md border border-neutral-300 bg-white px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-100 dark:hover:bg-neutral-900 ',
                ]"
                @click="intervalInDays = '7'"
              >
                {{ $t('collections.days7') }}
              </button>
              <button
                type="button"
                :class="[
                  intervalInDays === '30' ? 'z-10 border-emerald-500 outline-none ring-1 ring-emerald-500' : '',
                  'relative inline-flex items-center border border-neutral-300 bg-white px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-100 dark:hover:bg-neutral-900 ',
                ]"
                @click="intervalInDays = '30'"
              >
                {{ $t('collections.days30') }}
              </button>
              <button
                type="button"
                :class="[
                  intervalInDays === 'all' ? 'z-10 border-emerald-500 outline-none ring-1 ring-emerald-500' : '',
                  'relative inline-flex items-center rounded-r-md border border-neutral-300 bg-white px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-100 dark:hover:bg-neutral-900 ',
                ]"
                @click="intervalInDays = 'all'"
              >
                {{ $t('collections.allTime') }}
              </button>
            </span>
          </div>
          <CollectionTopTable :interval-in-days="intervalInDays" />
        </div>
      </Container>
    </div>
  </div>
</template>
